import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Axios } from "api/axios";
import { Card, Col, Form, Row } from "react-bootstrap";
import { autocompleteDropdownStyles, getDisabledInputStyles, DISABLED_INPUT_BG } from "Constants/Style";
import { useFormikContext, useField } from "formik";

export interface CustomerDetailsSectionProps {
  customerOptions?: any[];
  isLoadingCustomers?: boolean;
  disabled?: boolean;
}

const CustomerDetailsSection: React.FC<CustomerDetailsSectionProps> = ({
  customerOptions = [],
  isLoadingCustomers = false,
  disabled = false,
}) => {
  const formik = useFormikContext<any>();
  const [customerField, customerMeta] = useField("customer_name");
  const [contactPersonNameField, contactPersonNameMeta] = useField(
    "contact_person_name"
  );
  const [contactPersonPhoneField, contactPersonPhoneMeta] = useField(
    "contact_person_phone_no"
  );

  const [customerList, setCustomerList] = useState<any[]>([]);
  console.log("formik values in customer details section", formik.values);
  useEffect(() => {
    if (customerOptions.length > 0) {
      setCustomerList(customerOptions);
    } else {
      // Fetch customers if not provided
      const fetchCustomers = async () => {
        try {
          const response = await Axios.get("/master/customer/dropdown/");
          const data = Array.isArray(response.data)
            ? response.data
            : response.data?.data || response.data?.customer_name || [];
          setCustomerList(data);
        } catch (error) {
          console.error("Failed to fetch customers", error);
        }
      };
      fetchCustomers();
    }
  }, [customerOptions]);

  // Handle customer selection - auto-fill contact person details
  const handleCustomerChange = async (event: any, newValue: any) => {
    const customerName = newValue?.customer_name || "";
    const customerId = newValue?.customer_id || "";

    await formik.setFieldValue("customer_name", customerName);
    await formik.setFieldValue("customer_details", newValue);
    await formik.setFieldValue("customer_id", customerId);
    await formik.setFieldTouched("customer_name", true);
    formik.validateField("customer_name");

    // Auto-fill contact erson details ipf available
    if (newValue) {
      await formik.setFieldValue(
        "contact_person_name",
        newValue?.contact_person_name || "Autofill"
      );
      await formik.setFieldValue(
        "contact_person_phone_no",
        newValue?.contact_person_mobile_no || ""
      );
    } else {
      await formik.setFieldValue("contact_person_name", "");
      await formik.setFieldValue("contact_person_phone_no", "");
    }
  };

  console.log("customer list in customer details section", customerList);
  const selectedCustomer =
    customerList.find(
      (customer) => customer.customer_id === formik.values.customer_id
    ) || formik.values.customer_name;

  return (
    <>
      {/* <h6 className="card-title mb-3">Customer Details</h6> */}
      <Row>
        <Col xs={12} sm={12} lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Customer Name <span className="text-danger">*</span>
          </Form.Label>
          <Autocomplete
            options={customerList}
            size="small"
            disabled={disabled}
            getOptionLabel={(option: any) => {
              if (typeof option === "string") return option;
              const customerName = option?.customer_name || "";
              const customerNumber = option?.contact_number || "";
              return customerNumber ? `${customerName} (${customerNumber})` : customerName;
            }}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            loading={isLoadingCustomers}
            ListboxProps={autocompleteDropdownStyles.ListboxProps}
            renderOption={(props, option) =>
              autocompleteDropdownStyles.renderOption(
                props,
                option,
                (opt: any) => {
                  if (typeof opt === "string") return opt;
                  const customerName = opt?.customer_name || "";
                  const customerNumber = opt?.contact_number || "";
                  return customerNumber ? `${customerName} (${customerNumber})` : customerName;
                }
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={disabled ? "" : "Select Customer"}
                variant="outlined"
                size="small"
                error={!!(customerMeta.touched && customerMeta.error)}
                helperText={
                  customerMeta.touched && customerMeta.error
                    ? customerMeta.error
                    : ""
                }
                sx={{
                  ...autocompleteDropdownStyles.inputSx,
                  ...getDisabledInputStyles(disabled),
                }}
              />
            )}
          />
        </Col>

        <Col xs={12} sm={12} lg={6} className="mb-3">
          <Form.Label className="fw-semibold">Contact Person Name</Form.Label>
          <Form.Control
            type="text"
            name="contact_person_name"
            value={contactPersonNameField.value}
            onChange={contactPersonNameField.onChange}
            onBlur={contactPersonNameField.onBlur}
            disabled={disabled}
            placeholder={disabled ? "" : "Autofill"}
            isInvalid={
              !!(contactPersonNameMeta.touched && contactPersonNameMeta.error)
            }
            style={{
              backgroundColor: disabled ? DISABLED_INPUT_BG : undefined,
            }}
          />
          <Form.Control.Feedback type="invalid">
            {contactPersonNameMeta.touched && contactPersonNameMeta.error}
          </Form.Control.Feedback>
        </Col>
      </Row>
      <Row className="gy-3">
        <Col xs={12} sm={12} lg={6} className="mb-3">
          <Form.Label className="fw-semibold">
            Contact Person Phone No.
          </Form.Label>
          <Form.Control
            type="number"
            name="contact_person_phone_no"
            value={contactPersonPhoneField.value}
            onChange={contactPersonPhoneField.onChange}
            onBlur={contactPersonPhoneField.onBlur}
            disabled={disabled}
            placeholder={disabled ? "" : "Enter 10-digit phone number"}
            isInvalid={
              !!(contactPersonPhoneMeta.touched && contactPersonPhoneMeta.error)
            }
            // maxLength={10}
            // minLength={10}
            style={{
              backgroundColor: disabled ? DISABLED_INPUT_BG : undefined,
            }}
          />
          <Form.Control.Feedback type="invalid">
            {contactPersonPhoneMeta.touched && contactPersonPhoneMeta.error}
          </Form.Control.Feedback>
        </Col>
      </Row>
    </>
  );
};

export default CustomerDetailsSection;
